import { internalLogger } from '../../../interface/v1/clientOsLogger';
import { DeviceInfo, DevicePlugin, JWebWindow } from '../types';
import { jWebStates } from '../Initializer';
import { loggerDecorator } from '../../../interface/v1/clientOsLogger/decorators';

/**
 * Facade for Device plugin operations
 */
export class DevicePluginFacade {
  /**
   * Get the Device plugin
   */
  private static async getDevicePlugin(): Promise<DevicePlugin | undefined> {
    // Question: is there no registerDeviceServicePlugin?
    await this.isDevicePluginReady();

    const windowDevicePlugin: DevicePlugin = (window as JWebWindow)?.JWeb
      ?.Plugins?.Device;
    if (windowDevicePlugin === undefined) {
      internalLogger?.error(
        'Unable to obtain DevicePlugin (missing some JWeb plugin)'
      );
    }
    return windowDevicePlugin;
  }

  /**
   * A promise that resolves to true if the DevicePlugin is ready, otherwise false.
   */
  private static async isDevicePluginReady(): Promise<boolean> {
    // Is Jweb ready?
    await jWebStates.JWebLibrary;

    // Is the plugins registered?
    await jWebStates.defaultPluginsRegistered;

    // Was DevicePlugin installed?
    await jWebStates.plugins.Device;
    return true;
  }

  /**
   * Return information about the underlying device/os/platform
   */
  @loggerDecorator.debug.d3()
  public static async getDeviceInfo(): Promise<DeviceInfo> {
    const devicePlugin = await this.getDevicePlugin();

    return devicePlugin.getInfo().catch((error) => {
      internalLogger?.error('JWeb error: Error retrieving device info', error);
      throw error;
    });
  }
}
